import React from "react";
import "./styles/GiftCardTable.css";
import { Link } from "react-router-dom";
import { AiFillEye, AiFillDelete, AiFillEdit } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import "../../localisation/index"

const GiftCardTable = ({ data, deleteItem }) => {
  const {t} = useTranslation()
  return (
    <table className="gift-cards-table">
      <thead>
        <tr>
          <th>{t("giftCardTable.giftCard")}</th>
          <th>{t("giftCardTable.type")}</th>
          <th>{t("giftCardTable.image")}</th>
          <th>{t("giftCardTable.createdDate")}</th>
          <th>{t("giftCardTable.action")}</th>
        </tr>
      </thead>
      <tbody>
        {data?.map((row, index) => (
          <tr key={index}>
            <td>{row.title}</td>
            <td>{row.isPhysical ? "Physical" : "Digital"}</td>
            <td className="gc-table__image">
              <img src={row?.images[0]?.src || row?.templateImages[0]?.attachment} alt="" />
            </td>
            <td>{row.created_at?.slice(0, 10)}</td>
            <td className="gc-table__actions">
              <Link to={"/my-gift-card/" + row.id}>
                <AiFillEye className="gc-table-icons" />
              </Link>
              <Link to={row.isPhysical ? "/edit-physical-gift-card/" + row.id : "/edit-gift-card/" + row.id}>
                <AiFillEdit className="gc-table-icons" />
              </Link>
              <Link>
                <AiFillDelete
                  className="gc-table-icons"
                  onClick={() => deleteItem(row.id)}
                />
              </Link>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default GiftCardTable;